// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gVcY","index":"styles_index__3KsR5"};